import {
  Flex,
  Heading,
  Text,
  Image,
  Button,
  useMediaQuery,
  Box,
} from "@chakra-ui/react";
import {
  diverImg1,
  diverImg2,
  diverImg3,
  diverImg4,
} from "../../../../assets/exports";

const Diverse = () => {
  const [isMobile] = useMediaQuery("(max-width: 501px)");
  return (
    <Box mx="auto" textAlign="center" pt={{ base: "144px", md: "228px" }}>
      {" "}
      <Heading fontSize={["24px", "24px", "30px", "40px"]}>
        Diversity and Expertise
      </Heading>
      <Text pt="24px" color="#222425" fontSize={["14px", "16px", "20px"]}>
        At Fastamoni, our strength lies in the diversity and expertise of our
        workforce. We are proud to have a team that represents a wide range of
        backgrounds, perspectives, and experiences. This rich tapestry of talent
        drives our innovation and fuels our commitment to delivering exceptional
        financial technology solutions. Our diverse team of experts works
        collaboratively to solve complex challenges and provide cutting-edge
        services that meet the evolving needs of our global clients.
      </Text>
      <Box
        display={{ base: "none" }}
        mt="1.8rem"
        justifyContent="center"
        gap="7px"
      >
        <Image src={diverImg1} />
        <Image src={diverImg2} />
        <Image src={diverImg3} />
        <Image src={diverImg4} />
      </Box>
      <Button
        mt={{ base: "38px", md: "102px" }}
        mb="52px"
        h="60px"
        py="20px"
        fontWeight={500}
      >
        Explore Our Products
      </Button>
    </Box>
  );
};
export default Diverse;
